import { useState, useEffect } from 'react';
import { isMobile } from 'is-mobile';

/**
 * Custom hook for managing navbar state and responsive behavior
 * Handles screen size detection and navbar visibility logic
 */
export function useNavbar() {
  const [isNavbarOpen, setIsNavbarOpen] = useState<boolean>(!isMobile());
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(window.innerWidth < 1200);

  // Check screen size when it changes
  const handleResize = () => {
    const screenWidth = window.innerWidth;
    const smallScreen = screenWidth < 1200; // Include iPad and iPad Pro as tablet devices
    setIsSmallScreen(smallScreen);
    
    if (smallScreen) {
      setIsNavbarOpen(false);
    } else {
      setIsNavbarOpen(true);
    }
  };

  // Add resize listener
  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    isNavbarOpen,
    setIsNavbarOpen,
    isSmallScreen,
    setIsSmallScreen,
  };
}
